if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");
        // Tìm nút custom trong custom template
        this.customButton = document.getElementById("pl-custom-product-add");
        // Tìm nút fixed bottom add to cart
        this.fixedButton = document.getElementById("pl-fixed-add-btn");

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";

        // Lắng nghe sự kiện khi các radio input properties[Shape], properties[Color], properties[Backing] được chọn
        this.propertiesRetryCount = 0;
        this.setupPropertiesListeners();
      }

      setupPropertiesListeners() {
        // Tìm tất cả các radio inputs cho Shape, Color, Backing
        const shapeInputs = Array.from(
          document.querySelectorAll('input[name="properties[Shape]"]'),
        );
        const colorInputs = Array.from(
          document.querySelectorAll('input[name="properties[Color]"]'),
        );
        const backingInputs = Array.from(
          document.querySelectorAll('input[name="properties[Backing]"]'),
        );

        // Nếu có ít nhất một input tồn tại, thiết lập listeners
        if (
          shapeInputs.length > 0 ||
          colorInputs.length > 0 ||
          backingInputs.length > 0
        ) {
          // Lắng nghe cho tất cả Shape inputs
          shapeInputs.forEach((input) => {
            input.addEventListener("change", (event) => {
              if (event.target.checked) {
                const selectedValue = event.target.value;
                this.selectedShape = selectedValue;
                this.logAllProperties();
              }
            });
          });

          // Lắng nghe cho tất cả Color inputs
          colorInputs.forEach((input) => {
            input.addEventListener("change", (event) => {
              if (event.target.checked) {
                const selectedValue = event.target.value;
                this.selectedColor = selectedValue;
                this.logAllProperties();
              }
            });
          });

          // Lắng nghe cho tất cả Backing inputs
          backingInputs.forEach((input) => {
            input.addEventListener("change", (event) => {
              if (event.target.checked) {
                const selectedValue = event.target.value;
                this.selectedBacking = selectedValue;
                this.logAllProperties();
              }
            });
          });
        } else if (this.propertiesRetryCount < 5) {
          // Nếu elements chưa tồn tại, thử lại tối đa 5 lần
          this.propertiesRetryCount++;
          setTimeout(() => this.setupPropertiesListeners(), 100);
        }
      }

      logAllProperties() {
        // Lấy tất cả các giá trị hiện tại
        const shapeInput = document.querySelector(
          'input[name="properties[Shape]"]:checked',
        );
        const colorInput = document.querySelector(
          'input[name="properties[Color]"]:checked',
        );
        const backingInput = document.querySelector(
          'input[name="properties[Backing]"]:checked',
        );

        const shapeValue = shapeInput?.dataset.addonTitle || "";
        const colorValue = colorInput?.dataset.addonTitle || "";
        const backingValue = backingInput?.dataset.addonTitle || "";

        // Tạo string nối các giá trị: value1 / value2 / value3
        const propertiesString = `${shapeValue} / ${colorValue} / ${backingValue}`;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        const templateInput =
          document.getElementById("template_title") ||
          document.querySelector('input[type="hidden"][name="template_title"]');

        // Validate cho High Density Metallic: Bắt buộc chọn Color (Gold, Silver, Bronze)
        if (
          templateInput &&
          templateInput.value === "amlab_custom_template_high_density_metalic"
        ) {
          const colorInput = document.querySelector(
            'input[name="properties[Color]"]:checked',
          );
          if (!colorInput) {
            this.handleErrorMessage("Please select a Color (Gold, Silver, or Bronze) before proceeding.");
            const colorSelection = document.getElementById(
              "color-selection-hd-" + (this.dataset.sectionId || ""),
            );
            const colorError = document.getElementById(
              "pl-color-error-" + (this.dataset.sectionId || ""),
            );
            if (colorSelection) {
              colorSelection.classList.remove("pl-shake-error");
              void colorSelection.offsetWidth;
              colorSelection.classList.add("pl-shake-error");
            }
            if (colorError) {
              colorError.classList.remove("pl-hidden");
              colorError.scrollIntoView({
                behavior: "smooth",
                block: "center",
              });
            }
            return;
          }
        }

        // Validate cho High Density: Nếu chọn Type = Cut thì bắt buộc phải chọn Color
        if (
          templateInput &&
          templateInput.value === "amlab_custom_template_high_density"
        ) {
          const typeInput = document.querySelector(
            'input[name="properties[Type]"]:checked',
          );
          if (typeInput && typeInput.value === "Cut") {
            // Bước 1: Kiểm tra đã chọn Color chưa
            const colorInput = document.querySelector(
              'input[name="properties[Color]"]:checked',
            );
            if (!colorInput) {
              this.handleErrorMessage("Please select a Color for your logo.");
              // Hiển thị warning message riêng
              const colorError = document.getElementById(
                "pl-color-error-" + (this.dataset.sectionId || ""),
              );
              if (colorError) {
                colorError.classList.remove("pl-hidden");
                colorError.scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                });
              }
              return;
            }

            // Bước 2: Kiểm tra khách đã tick xác nhận giới hạn màu Cut chưa
            const cutConfirmCheckbox = document.getElementById(
              "cut-confirm-" + (this.dataset.sectionId || ""),
            );
            if (cutConfirmCheckbox && !cutConfirmCheckbox.checked) {
              // Lấy wrap để hiệu ứng shake + đổi màu border
              const cutConfirmWrap = document.getElementById(
                "cut-confirm-wrap-" + (this.dataset.sectionId || ""),
              );
              const cutConfirmError = document.getElementById(
                "pl-cut-confirm-error-" + (this.dataset.sectionId || ""),
              );

              if (cutConfirmWrap) {
                // Xóa rồi thêm lại class shake để animation chạy đúng mỗi lần
                cutConfirmWrap.classList.remove("pl-confirm-error");
                void cutConfirmWrap.offsetWidth; // Trigger reflow để reset animation
                cutConfirmWrap.classList.add("pl-confirm-error");

                // Scroll lên vị trí checkbox để khách thấy rõ
                cutConfirmWrap.scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                });
              }

              if (cutConfirmError) {
                cutConfirmError.classList.remove("pl-hidden");
              }

              return;
            }
          }
        }

        // Áp dụng loading cho nút submit chính
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        const spinner = this.submitButton.querySelector(".loading__spinner");
        if (spinner) {
          spinner.classList.remove("hidden");
        }

        // Áp dụng loading cho nút custom nếu có
        if (this.customButton) {
          this.customButton.setAttribute("aria-disabled", true);
          this.customButton.disabled = true;
          this.customButton.classList.add("loading");
          const customSpinner =
            this.customButton.querySelector(".loading__spinner");
          if (customSpinner) {
            customSpinner.classList.remove("hidden");
          }
        }
        // Áp dụng loading cho nút fixed bottom nếu có
        if (this.fixedButton) {
          this.fixedButton.setAttribute("aria-disabled", true);
          this.fixedButton.disabled = true;
          this.fixedButton.classList.add("loading");
          const fixedSpinner =
            this.fixedButton.querySelector(".loading__spinner");
          if (fixedSpinner) {
            fixedSpinner.classList.remove("hidden");
          }
        }

        const isCustomTemplate =
          templateInput &&
          (templateInput.value === "amlab_custom_template" ||
            templateInput.value === "amlab_custom_template_heat_transfer" ||
            templateInput.value === "amlab_custom_template_heat_transfer_new" ||
            templateInput.value === "amlab_custom_template_dtf" ||
            templateInput.value === "amlab_custom_template_dtf_new" ||
            templateInput.value === "amlab_custom_template_high_density" ||
            templateInput.value === "amlab_custom_template_high_density_metalic" ||
            templateInput.value === "amlab_custom_template_hang_tags" ||
            templateInput.value === "amlab_custom_template_zipper" ||
            templateInput.value === "amlab_custom_template_poly_mailer" ||
            templateInput.value === "amlab_custom_template_rubber_labels");
        let specialHandle =
          this.dataset.productHandle ||
          (window.location.pathname.includes("/products/")
            ? window.location.pathname.split("/products/")[1].split("/")[0]
            : "");
        if (!specialHandle) {
          const infoEl = document.querySelector("product-info");
          const dataUrl = infoEl ? infoEl.getAttribute("data-url") : "";
          if (dataUrl && dataUrl.includes("/products/")) {
            const part = dataUrl.split("/products/")[1];
            if (part) {
              const seg = part.split("/")[0];
              if (seg) {
                specialHandle = seg;
              }
            }
          }
        }
        if (isCustomTemplate) {
          const qtyInput = document.querySelector(
            'input[type="hidden"][name="quantity"]',
          );
          const qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
          const headers = {
            "Content-Type": "application/json",
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
          };
          const sections = this.cart ? this.cart.getSectionsToRender() : [];
          const sectionIds = sections.map((s) => s.id);

          // Lấy variant ID chính từ form
          const mainVariantIdValue = this.variantIdInput?.value;
          if (!mainVariantIdValue) {
            console.error("Main variant ID not found");
            this.error = true;
            return;
          }
          const mainVariantId = Number(mainVariantIdValue);
          if (!mainVariantId || isNaN(mainVariantId)) {
            console.error("Invalid variant ID:", mainVariantIdValue);
            this.error = true;
            return;
          }

          const updateSections = (response) => {
            if (!this.cart) return;

            // Đối với isCustomTemplate, luôn fetch lại sections để đảm bảo có đầy đủ thông tin mới nhất
            // Vì response.sections từ /cart/add.js có thể không đầy đủ (giá bị 0, metadata thiếu)
            const shouldRefetchSections = isCustomTemplate;

            if (!shouldRefetchSections && response && response.sections) {
              const quickAddModal = this.closest("quick-add-modal");
              if (quickAddModal) {
                document.body.addEventListener(
                  "modalClosed",
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true },
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: mainVariantId,
                cartData: response,
              });
              return;
            }

            // Luôn fetch lại sections từ server để đảm bảo có đầy đủ thông tin
            // Thêm delay nhỏ để đảm bảo server đã xử lý xong cart update
            const parsedState = { sections: {} };
            const fetchSections = () => {
              const requests = sectionIds.map((id) =>
                fetch(`${routes.cart_url}?section_id=${id}`, {
                  headers: {
                    "X-Requested-With": "XMLHttpRequest",
                  },
                })
                  .then((r) => (r.ok ? r.text() : ""))
                  .then((html) => {
                    if (html) parsedState.sections[id] = html;
                  })
                  .catch(() => {}),
              );

              return Promise.all(requests);
            };

            // Đối với isCustomTemplate, thêm delay nhỏ trước khi fetch để đảm bảo server đã xử lý xong
            const fetchPromise = shouldRefetchSections
              ? new Promise((resolve) => {
                  setTimeout(() => {
                    fetchSections().then(resolve);
                  }, 100); // Delay 100ms để đảm bảo server đã xử lý xong cart update
                })
              : fetchSections();

            fetchPromise.then(() => {
              const quickAddModal = this.closest("quick-add-modal");
              if (quickAddModal) {
                document.body.addEventListener(
                  "modalClosed",
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(parsedState);
                    });
                  },
                  { once: true },
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(parsedState);
              }
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: mainVariantId,
                cartData: parsedState,
              });
            });
          };

          this.cart?.setActiveElement(document.activeElement);

          // Thu thập metadata từ form
          const widthInput = document.querySelector('input[data-dim="w"]');
          const heightInput = document.querySelector('input[data-dim="h"]');
          let sizeInput = "";
          if (
            widthInput &&
            heightInput &&
            widthInput.value &&
            heightInput.value
          ) {
            sizeInput =
              widthInput.value + " in" + " x " + heightInput.value + " in";
          }

          const parseAreaNumber = (val) => {
            const s = String(val || "").trim();
            if (!s) return null;
            const whMatch = s.match(
              /([\d.,]+)\s*(?:[""]?)\s*[x×]\s*([\d.,]+)\s*(?:[""]?)/i,
            );
            if (whMatch) {
              const w = parseFloat(whMatch[1].replace(",", "."));
              const h = parseFloat(whMatch[2].replace(",", "."));
              const area = w * h;
              return Number.isFinite(area) ? area : null;
            }
            const num = parseFloat(s.replace(",", "."));
            return Number.isNaN(num) ? null : num;
          };

          const areaDisplayEl =
            document.querySelector('[id^="pl-area-"]') ||
            document.querySelector('[id^="pl-meas-display-"]') ||
            document.querySelector('[id^="pl-size-area-selected-"]');
          const displayArea = parseAreaNumber(
            (areaDisplayEl?.textContent || "").trim(),
          );

          const selectedMeasurement = (() => {
            const spans = Array.from(
              document.querySelectorAll("span[data-selected-value]"),
            );
            const match = spans.find((span) => {
              const legend =
                span
                  .closest(".product-form__input")
                  ?.querySelector(".form__label")
                  ?.textContent?.trim() || "";
              return legend.toLowerCase().includes("measurement");
            });
            return (match?.textContent || "").trim();
          })();

          const contactMethod =
            document.querySelector(
              'input[name="properties[Contact method]"]:checked',
            )?.value || "";

          const imageLinkInput = document.querySelector(
            'input[name="properties[Image link]"], input[name="properties[_logo_image_url]"], input[name="properties[Logo]"]',
          );

          // Thu thập Shape, Color, Backing từ radio inputs
          const shapeInput = document.querySelector(
            'input[name="properties[Shape]"]:checked',
          );
          const colorInput = document.querySelector(
            'input[name="properties[Color]"]:checked',
          );
          const backingInput = document.querySelector(
            'input[name="properties[Backing]"]:checked',
          );
          const preCutInput = document.querySelector(
            'input[name="properties[Pre-cut]"]:checked',
          );
          const designerNotesInput = document.querySelector(
            'input[name="properties[Designer Notes]"]',
          );

          // Thu thập Hang Tags properties
          const htPaperThicknessInput = document.querySelector('input[name="properties[Paper Thickness]"]:checked');
          const htPaperFinishInput = document.querySelector('input[name="properties[Paper Finish]"]:checked');
          const htPrintInput = document.querySelector('input[name="properties[Print Option]"]:checked');
          const htHolePositionInput = document.querySelector('input[name="properties[Hole Position]"]:checked');
          const htStringColorInput = document.querySelector('input[name="properties[String Color]"]:checked');
          const htFrontImageInput = document.querySelector('input[name="properties[Front Image]"]');
          const htBackImageInput = document.querySelector('input[name="properties[Back Image]"]');
          const typeInputProduct = document.querySelector(
            'input[name="properties[Type]"]:checked',
          );
          const sizeSplitInput = document.querySelector(
            'textarea[name="properties[Size Split note]"]',
          );
          const selectedTemplateInput = document.querySelector(
            'input[name="properties[Label Template]"]',
          );

          const area = displayArea ?? parseAreaNumber(selectedMeasurement) ?? 1;

          // Thu thập note designer nếu có
          let noteDesigner = "";
          if (contactMethod)
            noteDesigner += `Contact Method: ${contactMethod}\n`;
          noteDesigner += document.getElementById("pl-note")?.value || "";

          // Thu thập metadata của các addons đã được chọn
          const addonMetadata = {};
          const addonFieldsets = document.querySelectorAll('[id^="pl-addon-"]');
          addonFieldsets.forEach((fieldset) => {
            const checkedAddon = fieldset.querySelector(
              'input[type="radio"]:checked',
            );
            if (checkedAddon && checkedAddon.dataset.addonTitle) {
              // Lấy addon group name từ data attribute
              const addonGroup = checkedAddon.dataset.addonGroup || "";
              const addonTitle = checkedAddon.dataset.addonTitle || "";

              // Lưu metadata với key là addon group name
              if (addonGroup) {
                addonMetadata[`_addon_${addonGroup}`] = addonTitle;
              }
            }
          });

          // Tạo properties object với metadata
          const properties = {
            ...(preCutInput?.value ? { "Pre-cut": preCutInput.value } : {}),
            ...(sizeSplitInput?.value?.trim()
              ? { "Size Split note": sizeSplitInput.value.trim() }
              : {}),
            ...(selectedTemplateInput?.value
              ? { _labelTemplate: selectedTemplateInput.value }
              : {}),
            Quantity: (function () {
              if (
                templateInput &&
                (templateInput.value === "amlab_custom_template_dtf" ||
                  templateInput.value === "amlab_custom_template_dtf_new" ||
                  templateInput.value ===
                    "amlab_custom_template_heat_transfer" ||
                  templateInput.value ===
                    "amlab_custom_template_heat_transfer_new" ||
                  templateInput.value === "amlab_custom_template_high_density" ||
                  templateInput.value === "amlab_custom_template_high_density_metalic")
              ) {
                const firstQtyInput = document.querySelector(
                  'input[name="quantity_first"]',
                );
                if (firstQtyInput) return String(firstQtyInput.value) + " pcs";
              }
              return String(qty) + " pcs";
            })(),
            ...(templateInput?.value !== "amlab_custom_template_zipper" &&
            templateInput?.value !== "amlab_custom_template_poly_mailer"
              ? { _area_size: area }
              : {}),
            _main_product: "true",
            _main_product_handle: window.location.pathname,
            ...(sizeInput ? { _size: sizeInput } : {}),
            ...(contactMethod ? { _contact_method: contactMethod } : {}),
            ...(imageLinkInput?.value
              ? { _logo_image_url: imageLinkInput.value }
              : {}),
            ...(typeInputProduct?.value
              ? { Type: typeInputProduct.value }
              : {}),
            ...(colorInput?.value && (templateInput?.value === "amlab_custom_template_high_density_metalic" || typeInputProduct?.value === "Cut" || !typeInputProduct?.value)
              ? { Color: colorInput.value }
              : {}),
            // Xóa bỏ Line Item Property Shape dư thừa đối với template-amlab
            ...(shapeInput?.value && templateInput?.value !== "amlab_custom_template" 
              ? { Shape: shapeInput.value } 
              : {}),
            ...(htPaperThicknessInput?.value ? { "Paper Thickness": htPaperThicknessInput.value } : {}),
            ...(htPaperFinishInput?.value ? { "Paper Finish": htPaperFinishInput.value } : {}),
            ...(htPrintInput?.value ? { "Print Option": htPrintInput.value } : {}),
            ...(htHolePositionInput?.value ? { "Hole Position": htHolePositionInput.value } : {}),
            ...(htStringColorInput?.value ? { "String Color": htStringColorInput.value } : {}),
            ...(htFrontImageInput?.value ? { "Front Image": htFrontImageInput.value } : {}),
            ...(htBackImageInput?.value ? { "Back Image": htBackImageInput.value } : {}),
            ...addonMetadata,
          };

          const items = [];
          const timestamp = Date.now();
          const mainUid = "uid_" + timestamp;
          const productTitle = this.dataset.productTitle || "";

          if (preCutInput?.value === "Yes") {
            items.push({
              id: 53461271609623,
              quantity: 1,
              properties: {
                For: productTitle,
                _for_product_id: mainVariantId,
                _unique_id: mainUid,
              },
            });
          }

          properties._unique_id = mainUid;
          let finalQty = qty;
          if (
            templateInput &&
            (templateInput.value === "amlab_custom_template" ||
              templateInput.value === "amlab_custom_template_hang_tags" ||
              templateInput.value === "amlab_custom_template_zipper" ||
              templateInput.value === "amlab_custom_template_poly_mailer")
          ) {
            finalQty = 1;
          } else if (templateInput && templateInput.value === "amlab_custom_template_heat_transfer_new") {
            if (area > 3.0) {
              finalQty = Math.round(area * qty);
            }
          }

          if (templateInput.value === "amlab_custom_template_zipper") {
            const optionsRoot = document.getElementById(
              `amlab-zipper-options-${this.dataset.sectionId}`,
            );
            const zipperItemsJSON = optionsRoot?.dataset?.cartItems || "[]";
            const zipperItems = JSON.parse(zipperItemsJSON);

            if (zipperItems.length > 0) {
              zipperItems.forEach((item, index) => {
                if (index === 0) {
                  // Main product item
                  item.properties = {
                    ...properties,
                    ...(item.properties || {}),
                  };
                } else {
                  // Addon items
                  item.properties = {
                    For: productTitle,
                    _for_product_id: mainVariantId,
                    _unique_id: mainUid,
                  };
                }
                item.quantity = 1;
              });
              items.push(...zipperItems);
            } else {
              items.push({
                id: mainVariantId,
                quantity: finalQty,
                properties: properties,
              });
            }
          } else if (
            templateInput.value === "amlab_custom_template_poly_mailer"
          ) {
            const optionsRoot = document.getElementById(
              `amlab-poly-mailer-options-${this.dataset.sectionId}`,
            );
            const polyMailerItemsJSON = optionsRoot?.dataset?.cartItems || "[]";
            const polyMailerItems = JSON.parse(polyMailerItemsJSON);

            if (polyMailerItems.length > 0) {
              polyMailerItems.forEach((item, index) => {
                if (index === 0) {
                  // Main product item
                  item.properties = {
                    ...properties,
                    ...(item.properties || {}),
                  };
                } else {
                  // Addon items
                  item.properties = {
                    For: productTitle,
                    _for_product_id: mainVariantId,
                    _unique_id: mainUid,
                  };
                }
                item.quantity = 1;
              });
              items.push(...polyMailerItems);
            } else {
              items.push({
                id: mainVariantId,
                quantity: finalQty,
                properties: properties,
              });
            }
          } else if (
            templateInput.value === "amlab_custom_template_rubber_labels"
          ) {
            // Rubber Labels: đọc cart items từ amlab-rubber-labels-options (giống Zipper pattern)
            const rubberRoot = document.getElementById(
              `amlab-rubber-labels-options-${this.dataset.sectionId}`,
            );
            const rubberItemsJSON = rubberRoot?.dataset?.cartItems || "[]";
            let rubberItems = [];
            try {
              rubberItems = JSON.parse(rubberItemsJSON);
            } catch (e) {
              rubberItems = [];
            }

            if (rubberItems.length > 0) {
              rubberItems.forEach((item, index) => {
                if (index === 0) {
                  // Main product item — merge full properties
                  item.properties = {
                    ...properties,
                    ...(item.properties || {}),
                  };
                } else {
                  // Addon items — liên kết với main qua _unique_id
                  item.properties = {
                    For: productTitle,
                    _for_product_id: mainVariantId,
                    _unique_id: mainUid,
                  };
                }
                item.quantity = 1;
              });
              items.push(...rubberItems);
            } else {
              // Fallback: chỉ add main product nếu chưa có cart items
              items.push({
                id: mainVariantId,
                quantity: finalQty,
                properties: properties,
              });
            }
          } else if (
            templateInput.value === "amlab_custom_template_hang_tags"
          ) {
            // Hang Tags: đọc cart items (main + addons)
            const hangTagsRoot = document.getElementById(
              `amlab-hang-tags-options-${this.dataset.sectionId}`,
            );
            const hangTagsItemsJSON = hangTagsRoot?.dataset?.cartItems || "[]";
            let hangTagsItems = [];
            try {
              hangTagsItems = JSON.parse(hangTagsItemsJSON);
            } catch (e) {
              hangTagsItems = [];
            }

            if (hangTagsItems.length > 0) {
              hangTagsItems.forEach((item, index) => {
                if (index === 0) {
                  // Main product item
                  item.properties = {
                    ...properties,
                    ...(item.properties || {}),
                  };
                } else {
                  // Addon items
                  item.properties = {
                    ...item.properties,
                    For: productTitle,
                    _for_product_id: mainVariantId,
                    _unique_id: mainUid,
                  };
                }
                item.quantity = 1;
              });
              items.push(...hangTagsItems);
            } else {
              items.push({
                id: mainVariantId,
                quantity: finalQty,
                properties: properties,
              });
            }
          } else {
            items.push({
              id: mainVariantId,
              quantity: finalQty,
              properties: properties,
            });
          }

          const body = {
            items: items,
            sections: sectionIds,
            sections_url: window.location.pathname,
          };

          fetch(`/cart/add.js`, {
            method: "POST",
            headers,
            body: JSON.stringify(body),
          })
            .then((res) => res.json())
            .then((response) => {
              if (response && response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: "product-form",
                  productVariantId: mainVariantId,
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);
                this.error = true;
              } else {
                if (typeof window.sendAmlabAddToCartWebhook === 'function') {
                  window.sendAmlabAddToCartWebhook(response);
                }
                if (noteDesigner) {
                  fetch("/cart/update.js", {
                    method: "POST",
                    headers,
                    body: JSON.stringify({ note: noteDesigner }),
                  })
                    .then((res) => res.json())
                    .catch(() => null)
                    .finally(() => {
                      updateSections(response);
                    });
                } else {
                  updateSections(response);
                }
              }
            })
            .catch((e) => {
              console.error(e);
              this.error = true;
            })
            .finally(() => {
              this.submitButton.classList.remove("loading");
              if (this.cart && this.cart.classList.contains("is-empty"))
                this.cart.classList.remove("is-empty");
              if (!this.error)
                this.submitButton.removeAttribute("aria-disabled");
              const spinner =
                this.submitButton.querySelector(".loading__spinner");
              if (spinner) {
                spinner.classList.add("hidden");
              }
              // Xóa loading cho nút custom nếu có
              if (this.customButton) {
                this.customButton.classList.remove("loading");
                this.customButton.removeAttribute("aria-disabled");
                if (!this.error) {
                  this.customButton.disabled = false;
                }
                const customSpinner =
                  this.customButton.querySelector(".loading__spinner");
                if (customSpinner) {
                  customSpinner.classList.add("hidden");
                }
              }
              // Xóa loading cho nút fixed bottom nếu có
              if (this.fixedButton) {
                this.fixedButton.classList.remove("loading");
                this.fixedButton.removeAttribute("aria-disabled");
                if (!this.error) {
                  this.fixedButton.disabled = false;
                }
                const fixedSpinner =
                  this.fixedButton.querySelector(".loading__spinner");
                if (fixedSpinner) {
                  fixedSpinner.classList.add("hidden");
                }
              }
            });
          return;
        }

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);

        // Đảm bảo Shape, Color, Backing được thêm vào formData nếu có
        const shapeInput = document.querySelector(
          'input[name="properties[Shape]"]:checked',
        );
        const colorInput = document.querySelector(
          'input[name="properties[Color]"]:checked',
        );
        const backingInput = document.querySelector(
          'input[name="properties[Backing]"]:checked',
        );

        if (shapeInput && !formData.has("properties[Shape]")) {
          formData.append("properties[Shape]", shapeInput.value);
        }
        if (colorInput && !formData.has("properties[Color]")) {
          formData.append("properties[Color]", colorInput.value);
        }
        if (backingInput && !formData.has("properties[Backing]")) {
          formData.append("properties[Backing]", backingInput.value);
        }

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              if (typeof window.sendAmlabAddToCartWebhook === 'function') {
                window.sendAmlabAddToCartWebhook(response);
              }
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              if (typeof window.sendAmlabAddToCartWebhook === 'function') {
                window.sendAmlabAddToCartWebhook(response);
              }
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            }
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            const spinner =
              this.submitButton.querySelector(".loading__spinner");
            if (spinner) {
              spinner.classList.add("hidden");
            }
            // Xóa loading cho nút custom nếu có
            if (this.customButton) {
              this.customButton.classList.remove("loading");
              this.customButton.removeAttribute("aria-disabled");
              if (!this.error) {
                this.customButton.disabled = false;
              }
              const customSpinner =
                this.customButton.querySelector(".loading__spinner");
              if (customSpinner) {
                customSpinner.classList.add("hidden");
              }
            }
            // Xóa loading cho nút fixed bottom nếu có
            if (this.fixedButton) {
              this.fixedButton.classList.remove("loading");
              this.fixedButton.removeAttribute("aria-disabled");
              if (!this.error) {
                this.fixedButton.disabled = false;
              }
              const fixedSpinner =
                this.fixedButton.querySelector(".loading__spinner");
              if (fixedSpinner) {
                fixedSpinner.classList.add("hidden");
              }
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    },
  );
}

// --- AMLAB WEBHOOK ADD TO CART ---
window.sendAmlabAddToCartWebhook = function(addResponse) {
  if (!addResponse) return;
  const addedItems = addResponse.items ? addResponse.items : [addResponse];
  if (!addedItems || addedItems.length === 0) return;

  fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
    .then(res => res.json())
    .then(cart => {
      let sessionId = sessionStorage.getItem('amlab_session_id');
      if (!sessionId) {
        sessionId = typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID() : 'sess_' + Date.now() + Math.random().toString(36).substring(2);
        sessionStorage.setItem('amlab_session_id', sessionId);
      }

      const urlParams = new URLSearchParams(window.location.search);
      
      const basePayload = {
        event: "add_to_cart",
        event_time: new Date().toISOString(),
        shop: "packlove-us",
        cart_token: cart.token || null,
        session_id: sessionId,
        customer_email: window.amlab_customer_email || null,
        customer_phone: window.amlab_customer_phone || null,
        cart: {
          items_count: cart.item_count || 0,
          subtotal: cart.items_subtotal_price ? cart.items_subtotal_price / 100 : 0,
          currency: cart.currency || "USD"
        },
        page: {
          url: window.location.href,
          referrer: document.referrer || "",
          landing_site: "/",
          utm_source: urlParams.get('utm_source') || null,
          utm_medium: urlParams.get('utm_medium') || null,
          utm_campaign: urlParams.get('utm_campaign') || null,
          utm_content: urlParams.get('utm_content') || null,
          utm_term: urlParams.get('utm_term') || null,
          fbclid: urlParams.get('fbclid') || null
        },
        user_agent: navigator.userAgent,
        ip: null
      };

      addedItems.forEach(item => {
        const itemPayload = {
          ...basePayload,
          item: {
            product_id: item.product_id,
            variant_id: item.variant_id,
            title: item.product_title || item.title || "",
            variant_title: item.variant_title || "",
            quantity: item.quantity,
            price: item.price ? item.price / 100 : 0,
            currency: cart.currency || "USD",
            properties: item.properties || {}
          }
        };

        fetch('https://n8n.bigwhy.top/webhook/packlove-us-notify', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(itemPayload)
        }).catch(e => console.error('Webhook error:', e));
      });
    })
    .catch(e => console.error('Cart fetch error:', e));
};
